/** German (de-CH). Swiss spelling: "ss", never "ß". */
export const de = {
  'app.name': 'VeloStube',
  'nav.home': 'Start',
  'nav.devices': 'Geräte',
  'nav.ride': 'Fahren',
  'nav.workouts': 'Workouts',
  'nav.calendar': 'Kalender',
  'nav.routes': 'Routen',
  'nav.rides': 'Fahrten',
  'nav.group': 'Gruppenfahrt',
  'nav.settings': 'Einstellungen',
  'nav.debug': 'BLE-Debug',
  'nav.setup': 'Einrichtung',
  'nav.menu': 'Menü',
  'topbar.trainer': 'Trainer',
  'topbar.hr': 'Puls',
  'topbar.notPaired': 'nicht gekoppelt',

  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.duplicate': 'Duplizieren',
  'common.edit': 'Bearbeiten',
  'common.start': 'Starten',
  'common.stop': 'Stoppen',
  'common.close': 'Schliessen',
  'common.back': 'Zurück',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.import': 'Importieren',
  'common.export': 'Exportieren',
  'common.loading': 'Lädt …',
  'common.none': 'Keine',
  'common.minutes': 'Min.',
  'common.connect': 'Verbinden',
  'common.disconnect': 'Trennen',
  'common.reconnect': 'Neu verbinden',
  'common.connected': 'Verbunden',
  'common.disconnected': 'Getrennt',
  'common.connecting': 'Verbindet …',
  'common.simulator': 'Simulator',

  'home.title': 'Grüezi{name}!',
  'home.weekNone': 'diese Woche noch keine Fahrt',
  'home.weekSome': 'diese Woche {n}× gefahren, {time} h',
  'home.weekLabel': 'Diese Woche',
  'home.kpiTime': 'Fahrzeit',
  'home.kpiDistance': 'Distanz',
  'home.kpiClimb': 'Höhenmeter',
  'home.kpiTss': 'Trainingsbelastung (TSS)',
  'home.kpiRides': '{n} Fahrten seit Montag',
  'home.sinceMonday': 'seit Montag',
  'home.viewAll': 'Alle anzeigen',
  'home.plan': 'Planen',
  'home.routeDetails': 'Karte und Profil',
  'home.routeDistance': 'Distanz',
  'home.routeAscent': 'Aufstieg',
  'home.routeTop': 'höchster Punkt',
  'home.routeClimb': 'längster Anstieg',
  'home.featuredCta': 'Route fahren',

  'onboarding.title': 'Willkommen – wie hoch ist deine FTP?',
  'onboarding.lead':
    'Die FTP (Functional Threshold Power) ist die Leistung, die du rund eine Stunde halten kannst. Workouts, Zonen und TSS richten sich danach.',
  'onboarding.once':
    'Du gibst sie nur dieses eine Mal ein. Danach ändert sie sich nur noch durch einen FTP-Test in der App – das Resultat wird automatisch übernommen.',
  'onboarding.ftp': 'FTP (Watt)',
  'onboarding.weight': 'Körpergewicht (kg)',
  'onboarding.hint':
    'Keine Ahnung? Hobbyfahrer liegen oft bei 2.5–3.5 W/kg. Trag eine Schätzung ein und mach bald den Rampentest.',
  'onboarding.wkg': '{wkg} W/kg',
  'onboarding.invalid': 'Bitte eine FTP zwischen {min} und {max} W eingeben.',
  'onboarding.submit': 'FTP festlegen und loslegen',

  'home.today': 'Heutiges Workout',
  'home.noToday': 'Für heute ist nichts geplant.',
  'home.startToday': 'Jetzt starten',
  'home.quick': 'Schnellstart',
  'home.freeRide': 'Freie Fahrt',
  'home.workout': 'Workout fahren',
  'home.group': 'Gruppenfahrt',
  'home.lastRides': 'Letzte Fahrten',
  'home.noRides': 'Noch keine Fahrten.',
  'home.recover': 'Eine unterbrochene Fahrt wurde gefunden.',
  'home.recoverResume': 'Fortsetzen',
  'home.recoverSave': 'Speichern',
  'home.recoverDiscard': 'Verwerfen',

  'first.title': 'Erste Schritte',
  'first.settings': 'FTP und Gewicht eingetragen',
  'first.trainer': 'Trainer koppeln (Geräte)',
  'first.ride': 'Erste Fahrt starten – Demo-Rundkurs oder eigene GPX-Route',
  'first.hint': 'Ohne Trainer zum Ausprobieren: Adresse mit ?sim=1 öffnen (Simulator).',
  'first.dismiss': 'Ausblenden',

  'error.title': 'Da ist etwas schiefgelaufen.',
  'error.hint':
    'Diese Ansicht ist abgestürzt. Eine laufende Fahrt wird alle 10 s gesichert und kann nach dem Neuladen fortgesetzt werden.',
  'error.reload': 'Neu laden',

  'devices.title': 'Geräte',
  'devices.trainer': 'Smart-Trainer',
  'devices.hr': 'Herzfrequenz',
  'devices.power': 'Leistungsmesser (CPS)',
  'devices.click': 'Zwift Click',
  'devices.pair': 'Koppeln',
  'devices.pairSim': 'Simulator koppeln',
  'devices.battery': 'Batterie',
  'devices.mode': 'Protokoll',
  'devices.noBluetooth':
    'Web Bluetooth ist in diesem Browser nicht verfügbar. Bitte Chrome auf dem Desktop verwenden (localhost oder HTTPS).',
  'devices.clickFlagOff':
    'Zwift Click ist experimentell. Aktiviere es unter Einstellungen → Experimentell. Die Tastatur (←/→) funktioniert immer.',
  'devices.mapping': 'Tastenbelegung',
  'devices.mappingHint': 'Klicke auf «Zuweisen» und drücke dann eine Taste am Controller.',
  'devices.assign': 'Zuweisen',
  'devices.pressButton': 'Taste drücken …',
  'devices.reconnecting': 'Verbindung verloren – verbinde neu …',
  'devices.rememberedHint':
    'Gemerkte Geräte werden automatisch verbunden, wenn chrome://flags/#enable-web-bluetooth-new-permissions-backend aktiv ist.',

  'action.shiftUp': 'Hochschalten',
  'action.shiftDown': 'Runterschalten',
  'action.ergUp': 'ERG +5 W',
  'action.ergDown': 'ERG −5 W',
  'action.skip': 'Intervall überspringen',
  'action.pause': 'Pause',
  'action.lap': 'Runde',
  'action.camera': 'Kamera',
  'action.none': '—',

  'ride.title': 'Fahren',
  'ride.chooseRoute': 'Route wählen',
  'ride.chooseWorkout': 'Workout wählen (optional)',
  'ride.noWorkout': 'Kein Workout – freie Fahrt',
  'ride.mode': 'Modus',
  'ride.view3d': '3D-Welt',
  'ride.viewWorkout': 'Workout-Ansicht (ohne 3D)',
  'ride.start': 'Losfahren',
  'ride.power': 'Leistung',
  'ride.cadence': 'Kadenz',
  'ride.hr': 'Puls',
  'ride.speed': 'Tempo',
  'ride.distance': 'Distanz',
  'ride.elevation': 'Höhe',
  'ride.time': 'Zeit',
  'ride.gear': 'Gang',
  'ride.grade': 'Steigung',
  'ride.draft': 'Windschatten {pct} %',
  'ride.paused': 'Pausiert',
  'ride.autoPaused': 'Auto-Pause',
  'ride.resume': 'Weiter',
  'ride.finish': 'Fahrt beenden',
  'ride.menu': 'Menü',
  'ride.lap': 'Runde {n}',
  'ride.finishTitle': 'Ziel erreicht!',
  'ride.turnAround': 'Umkehren',
  'ride.target': 'Ziel',
  'ride.next': 'Nächstes',
  'ride.interval': 'Intervall',
  'ride.ergOn': 'ERG an',
  'ride.ergOff': 'ERG aus',
  'ride.extend': '+1 Min.',
  'ride.intensity': 'Intensität',
  'ride.noTrainer': 'Kein Trainer verbunden.',
  'ride.trainerLost': 'Trainer getrennt – Fahrt läuft weiter, verbinde neu …',
  'ride.lowCadence': 'Kadenz tief – ERG reduziert',
  'ride.camera': 'Kamera',
  'ride.difficulty': 'Schwierigkeit',
  'ride.fullscreen': 'Vollbild',
  'ride.discard': 'Fahrt verwerfen',
  'ride.discardConfirm': 'Wirklich verwerfen? Die Fahrt wird nicht gespeichert.',
  'ride.qualityDowngraded': 'Grafik automatisch auf «{q}» reduziert (zu wenig fps)',

  'mode.erg': 'ERG',
  'mode.sim': 'SIM',
  'mode.vs': 'Virtuelles Schalten',

  'workouts.title': 'Workouts',
  'workouts.new': 'Neues Workout',
  'workouts.library': 'Bibliothek',
  'workouts.builtin': 'Vorlage',
  'workouts.importZwo': '.zwo importieren',
  'workouts.exportZwo': '.zwo exportieren',
  'workouts.unsupported': 'Nicht unterstützte Elemente ignoriert: {list}',
  'workouts.duration': 'Dauer',
  'workouts.tss': 'TSS',
  'workouts.if': 'IF',
  'workouts.name': 'Name',
  'workouts.description': 'Beschreibung',
  'workouts.tags': 'Tags',
  'block.warmup': 'Aufwärmen (Rampe)',
  'block.steady': 'Konstant',
  'block.intervals': 'Intervall-Set',
  'block.cooldown': 'Ausfahren (Rampe)',
  'block.free': 'Freie Fahrt',
  'block.ramp': 'Rampe',
  'block.repeat': 'Wiederholung',
  'block.times': 'Wiederholungen',
  'block.on': 'Belastung',
  'block.off': 'Erholung',
  'block.from': 'Von',
  'block.to': 'Bis',
  'block.target': 'Ziel',
  'block.cadence': 'Kadenz',
  'block.label': 'Bezeichnung',
  'target.ftp': '% FTP',
  'target.watts': 'Watt',

  'calendar.title': 'Kalender',
  'calendar.week': 'Woche',
  'calendar.month': 'Monat',
  'calendar.today': 'Heute',
  'calendar.dragHint': 'Workout auf einen Tag ziehen, um es zu planen.',
  'calendar.done': 'Erledigt',
  'calendar.skipped': 'Ausgelassen',
  'calendar.planned': 'Geplant',
  'calendar.markDone': 'Als erledigt markieren',
  'calendar.markSkipped': 'Auslassen',
  'calendar.remove': 'Entfernen',
  'weekday.short': 'Mo,Di,Mi,Do,Fr,Sa,So',

  'routes.title': 'Routen',
  'routes.import': 'GPX importieren',
  'routes.importing': 'Importiere …',
  'routes.step.parse': 'GPX lesen',
  'routes.step.project': 'LV95 umrechnen',
  'routes.step.resample': 'Neu abtasten (10 m)',
  'routes.step.elevation': 'Höhen von swisstopo',
  'routes.step.smooth': 'Glätten',
  'routes.step.save': 'Speichern',
  'routes.demo': 'Demo-Rundkurs',
  'routes.loop': 'Rundkurs',
  'routes.oneWay': 'Einweg',
  'routes.outAndBack': 'Hin und zurück',
  'routes.ascent': 'Aufstieg',
  'routes.climbs': 'Anstiege',
  'routes.elevationSource': 'Höhenquelle',
  'routes.source.swisstopo': 'swisstopo',
  'routes.source.gpx': 'GPX',
  'routes.source.synthetic': 'synthetisch',
  'routes.fallbackWarning': 'swisstopo nicht erreichbar oder ausserhalb der Schweiz – GPX-Höhen verwendet.',

  'rides.title': 'Fahrten',
  'rides.empty': 'Noch keine Fahrten aufgezeichnet.',
  'rides.downloadFit': '.fit herunterladen',
  'rides.strava': 'Strava',
  'rides.stravaUpload': 'Zu Strava hochladen',
  'rides.stravaUploading': 'Lädt zu Strava hoch …',
  'rides.stravaDone': 'Auf Strava ansehen',
  'rides.stravaError': 'Strava-Fehler: {msg}',
  'rides.stravaAsk':
    'Diese Fahrt zu Strava hochladen? (Achtung: Duplikate, falls dein Garmin auch hochlädt.)',
  'rides.delete': 'Fahrt löschen',

  'summary.title': 'Zusammenfassung',
  'summary.duration': 'Dauer',
  'summary.distance': 'Distanz',
  'summary.elevationGain': 'Höhenmeter',
  'summary.avgPower': 'Ø Leistung',
  'summary.maxPower': 'Max. Leistung',
  'summary.np': 'NP',
  'summary.if': 'IF',
  'summary.tss': 'TSS',
  'summary.avgHr': 'Ø Puls',
  'summary.maxHr': 'Max. Puls',
  'summary.kj': 'Arbeit',
  'summary.zones': 'Zeit in Zonen',
  'summary.curve': 'Bestwerte',
  'summary.charts': 'Verlauf',
  'summary.ftpUpdated': 'Neue FTP: {ftp} W',
  'summary.ftpUpdatedFrom': 'Automatisch übernommen (bisher {old} W).',
  'summary.ftpIncomplete': 'FTP-Test nicht abgeschlossen – deine FTP bleibt unverändert.',

  'group.title': 'Gruppenfahrt',
  'group.create': 'Raum erstellen',
  'group.join': 'Beitreten',
  'group.code': 'Raum-Code',
  'group.invite': 'Einladungslink',
  'group.copy': 'Kopieren',
  'group.lobby': 'Lobby',
  'group.ready': 'Bereit',
  'group.notReady': 'Nicht bereit',
  'group.startCountdown': 'Countdown starten',
  'group.countdown': 'Start in {s} s',
  'group.host': 'Gastgeber',
  'group.loginRequired': 'Für Gruppenfahrten musst du mit Strava angemeldet sein.',
  'group.full': 'Der Raum ist voll (max. 10).',
  'group.riders': 'Fahrer',

  'settings.title': 'Einstellungen',
  'settings.profile': 'Profil',
  'settings.displayName': 'Anzeigename',
  'settings.ftp': 'FTP',
  'settings.riderWeight': 'Fahrergewicht (kg)',
  'settings.bike': 'Standard-Rennvelo',
  'settings.bikeHint':
    'Alle fahren mit demselben Velo – fix, damit Zeiten und Gruppenfahrten vergleichbar bleiben.',
  'settings.bikeWeight': 'Gewicht',
  'settings.bikeCda': 'Luftwiderstand (CdA, Hände auf den Bremsgriffen)',
  'settings.bikeWheel': 'Radumfang (700×25C)',
  'settings.bikeGears': 'Virtuelle Gänge',
  'settings.bikeGearsValue': '{count} Gänge, {min} – {max}',
  'settings.bikeDraft': 'Windschatten',
  'settings.bikeDraftValue': 'bis {pct} % weniger Luftwiderstand',
  'settings.ftpLocked':
    'Deine FTP ändert sich nur durch einen FTP-Test – das Resultat wird automatisch übernommen.',
  'settings.ftpFromTest': 'aus FTP-Test vom {date}',
  'settings.ftpFromOnboarding': 'Startwert vom {date}',
  'settings.rampTest': 'Rampentest starten',
  'settings.ftp20Test': '20-Min.-Test starten',
  'settings.color': 'Farbe (Avatar und Karte)',
  'settings.trainerHint':
    'Wie stark Steigungen auf dem Trainer spürbar sind und wie das virtuelle Schalten den Widerstand steuert.',
  'settings.rideHint': 'Verhalten während und nach der Fahrt.',
  'settings.accountHint': 'Mit Strava anmelden für Synchronisation, Upload und Gruppenfahrten.',
  'settings.experimentalHint': 'Funktionen, die auf echter Hardware noch nicht geprüft sind.',
  'settings.trainer': 'Trainer',
  'settings.difficulty': 'Trainer-Schwierigkeit (%)',
  'settings.vsStrategy': 'VS-Strategie',
  'settings.vsA': 'A – Steigung vorsteuern (Standard)',
  'settings.vsB': 'B – Kadenz-ERG (Fallback)',
  'settings.defaultMode': 'Standardmodus für freie Fahrt',
  'settings.ride': 'Fahrt',
  'settings.autoPause': 'Auto-Pause',
  'settings.upload': 'Strava-Upload',
  'settings.upload.auto': 'Automatisch',
  'settings.upload.ask': 'Fragen',
  'settings.upload.off': 'Aus',
  'settings.quality': 'Grafikqualität',
  'settings.quality.low': 'Tief',
  'settings.quality.medium': 'Mittel',
  'settings.quality.high': 'Hoch',
  'settings.language': 'Sprache',
  'settings.experimental': 'Experimentell',
  'settings.clickFlag': 'Zwift Click aktivieren (experimentell)',
  'settings.clickEncrypted': 'Click: verschlüsselten Handshake verwenden (ältere Firmware)',
  'settings.vsDebug': 'VS-Debug-Overlay anzeigen',
  'settings.account': 'Konto',
  'settings.guest': 'Gastmodus – alles bleibt lokal auf diesem Gerät.',
  'settings.connectStrava': 'Mit Strava verbinden',
  'settings.loggedInAs': 'Angemeldet als {name}',
  'settings.logout': 'Abmelden',
  'settings.saved': 'Gespeichert',
  'settings.sync': 'Jetzt synchronisieren',
  'settings.syncing': 'Synchronisiere …',
  'settings.poweredByStrava': 'Powered by Strava',

  'debug.title': 'BLE-Debug',
  'debug.pick': 'Gerät wählen',
  'debug.pickSim': 'Simulator-Gerät',
  'debug.services': 'Services & Charakteristiken',
  'debug.subscribe': 'Abonnieren',
  'debug.unsubscribe': 'Abo beenden',
  'debug.read': 'Lesen',
  'debug.write': 'Schreiben',
  'debug.writeHex': 'Hex schreiben',
  'debug.log': 'Log',
  'debug.exportJson': 'Log als JSON exportieren',
  'debug.clear': 'Leeren',

  'zone.1': 'Z1 Erholung',
  'zone.2': 'Z2 Grundlage',
  'zone.3': 'Z3 Tempo',
  'zone.4': 'Z4 Schwelle',
  'zone.5': 'Z5 VO2max',
  'zone.6': 'Z6 Anaerob',
  'zone.7': 'Z7 Neuromuskulär',

  'misc.notFound': 'Seite nicht gefunden.',
  'misc.simBanner': 'Simulator-Modus aktiv (?sim=1)',
} as const;

export type MessageKey = keyof typeof de;
